import Stack, { StackProps } from "@mui/material/Stack"
import { ReactNode } from "react"


export interface RowProps extends StackProps {
    
} 

export const Row = (props: RowProps) => (
    <Stack {...props} direction={"row"}/>
)

export interface ColumnProps extends StackProps {
    
} 

export const Column = (props: ColumnProps) => (
    <Stack {...props} direction={"column"}/>
)
